var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},domProps:{"value":(_vm.val)},on:{"input":function($event){if($event.target.composing)return;_vm.val=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }